<template>
<div>
    <Header></Header>
<div class="d-flex flex-column justify-content-start align-items-center page-div">                       
    <b-form class="form-style">
        <div class="d-flex flex-column align-items-center align-content-center justify-content-center" v-if="retrievingServices">            
            <h3>Please wait while we retrieve the available services</h3>
            <br>            
            <img src="@/assets/img-occu/loading.gif" style="height:100px" />                                      
        </div>
        <b-form-group label="What type of service would you like to schedule today?" v-if="!retrievingServices">            
            <b-button-group vertical class="button-group">
                <b-button v-for="service in services" @click="selectService(service)" :pressed.sync="service.coreId === selectedService" :key="service.coreId" variant="outline-primary">
                    <span class="btn-text">{{ service.description }}</span>
                </b-button>                
            </b-button-group>
        </b-form-group>
        <div v-if="selectedService === 'REALESTATE'">
            <h3>Please contact us at 800-426-5657 to schedule an appointment.</h3>
            <br />
            <ul>
                <li>Home Equity or Land Loans choose option 5</li>
                <li>Mortgage Loans  choose option 6</li>
            </ul>
        </div>
        <div v-if="selectedService && selectedService !== 'REALESTATE'">
            <b-form-group label="Please select the branch you would like to visit:" v-if="selectedService">
                <b-button-group vertical class="button-group">
                    <b-button v-for="branch in availableLocations" @click="selectBranch(branch)" :pressed.sync="branch.name === selectedBranch" :key="branch.name" variant="outline-primary">
                        <span class="btn-text">{{ branch.name }}</span>
                    </b-button>
                </b-button-group>
            </b-form-group>
            <div v-if="selectedBranch">
                <b-form-group label="Appointment Date">                                                    
                    <datepicker :disabled-dates="disabledDates" v-model="appointmentDate" maximum-view="month" placeholder="mm/dd/yyyy" format="MM/dd/yyyy" :input-class="{ 'form-control': true, 'field-error': $v.appointmentTime.$error && $v.appointmentTime.$dirty }" name="appointmentDate" :calendar-button="false" calendar-button-icon="fa fa-calendar" :bootstrap-styling="true" :typeable="true" v-mask="'##/##/####'"></datepicker>                                
                </b-form-group>
                <b-form-group label="Appointment Time" v-if="!retrievingAppointments">
                    <div class="d-flex flex-row flex-wrap align-items-center justify-content-start">                    
                        <b-button @click="mobileSelectTime(time)" variant="outline-primary" :pressed="isSelectedTime(time)" class="button-selector" :key="time" v-for="time in availableAppointmentTimes" style="font-size: large !important;">
                            {{ time }}
                        </b-button>                                 
                        <h3 class="text-center" v-if="availableAppointmentTimes.length === 0">There are no available appointments on this date.</h3>
                    </div>     
                    <div class="field-error-message" v-if="!$v.appointmentTime.required && $v.appointmentTime.$dirty">Please select an appointment time</div>             
                </b-form-group>  
                    
                <div class="d-flex flex-column align-items-center align-content-center justify-content-center" v-if="retrievingAppointments">            
                    <h3>Please wait while we retrieve the available appointment times</h3>
                    <img src="@/assets/img-occu/loading.gif" style="height:100px"/>                                      
                </div>
                <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:50px;margin-bottom:30px">
                    <b-button @click="next()" variant="primary" class="button-style">Next</b-button>
                </div>
            </div>
        </div>
    </b-form>  
    <b-modal ref="errorModalRef" header-bg-variant="dark" header-text-variant="light" body-bg-variant="dark" footer-bg-variant="dark" body-text-variant="light" footer-text-variant="light" :ycentered=true centered title="Missing Information">
        Please fill out all information on the form to continue with scheduling.
        <div slot="modal-footer">
            <b-button variant="primary" pill class="modal-btn" @click="dismissModal()">OK</b-button>
        </div>
    </b-modal> 
</div>           
</div>
</template>
<script>
import Header from '@/components/Header';
import store from '@/store';
import { required } from "vuelidate/lib/validators";
import { mask } from "vue-the-mask";
import moment from 'moment';
import { mapState } from "vuex";
import Datepicker from 'vuejs-datepicker';

export default {
    name: "SelectService",
    components: {
        Datepicker,
        Header
    },
    async beforeRouteEnter(to, from, next) {    
        //await store.commit("resetData");            
        next();
    },
    async beforeRouteUpdate(to, from, next) {    
        //await store.commit("resetData");                   
        next();
    },
    watch: {
        appointmentDate: function(newDate) {            
            store.dispatch("getAppointmentTimes", { date: newDate });    
        }
    },
    directives: {
        mask
    },
    mounted: function() {  
        this.appointmentTime = new Date();          
        store.dispatch("getAppointmentTimes", { date: this.appointmentDate });      
    },
    data: function() {
        return {                        
            appointmentDate: new Date(),            
            disabledDates: {
                days: [0, 6],
                to: new moment().subtract(1, 'days').toDate(),
                from: new moment().add(7, 'days').toDate(),
            },  
        }        
    },
    methods: {
        selectService(service) {            
            this.selectedService = service.coreId;
            this.selectedServiceDescription = service.description;
            this.selectedBranch = '';
            this.$store.commit('setAppointmentTime', '');
        },        
        selectBranch(branch) {
            console.info('branch', branch);
            this.selectedBranch = branch.name;            
            this.$store.commit('setLocation', branch);            
            this.$store.commit('setAppointmentTime', '');
            store.dispatch("getAppointmentTimes", { date: this.appointmentDate });    
        },     
        mobileSelectTime: async function(time) {
            if(!this.retrievingAppointments) {
                this.$store.commit('setAppointmentDate', this.appointmentDate);
                this.$store.commit('setAppointmentTime', time);
            }
        },
        isSelectedTime: function(time) {
            return time === this.appointmentTime;
        },
        next() {
            this.$v.$touch();

            console.info('validation', this.$v);
            if (this.$v.$invalid) {
                this.$refs.errorModalRef.show();
            } else {
                // Todo: are we verifying membership?
                // await this.$store.dispatch("verifyMembership");
                this.$router.push('contactinfo');
            }
            
        },
        dismissModal() {
            this.$refs.errorModalRef.hide();
        }
    },
    computed: {
        ...mapState({
            isMember: state => state.isMember,
            memberIdentifier: state => state.person.memberIdentifier,
            appointment: state => state.appointment,     
            verifyingMembership: state => state.verifyingMembership,  
            retrievingAppointments: state => state.retrievingAppointments,            
            retrievingServices: state => state.retrievingServices,     
            availableAppointmentTimes: state => state.availableAppointmentTimes                 
        }),        
        appointmentTime: {
            get() {
                return this.$store.state.appointmentTime;
            },
            set(value) {
                this.$store.commit('setAppointmentTime', value);
            }
        },
        firstName: { 
            get() {
                return this.$store.state.person.firstName;
            }, 
            set(value) {                
                this.$store.commit('setFirstName', value);
            }
        },
        lastName: { 
            get() {
                return this.$store.state.person.lastName;
            }, 
            set(value) {
                this.$store.commit('setLastName', value);
            }
        },
        memberIdentifier: {
            get() {
                return this.$store.state.person.memberIdentifier;
            }, 
            set(value) {
                this.$store.commit('setMemberIdentifier', value);
            }
        },        
        scheduledDate: function() {
            if(this.appointment.scheduledStart) {
                return moment(this.appointment.scheduledStart).format("MM/DD/YYYY");
            } else {
                return '';
            }
        },
        scheduledTime: function() {
            if(this.appointment.scheduledStart) {
                return moment(this.appointment.scheduledStart).format("hh:mmA");
            } else {
                return '';
            }
        },
        phoneNumber: { 
            get() {
                return this.$store.state.person.phoneNumber;
            }, 
            set(value) {                
                this.$store.commit('setPhoneNumber', value);
            }
        },
        emailAddress: { 
            get() {
                return this.$store.state.person.email;
            }, 
            set(value) {                
                this.$store.commit('setEmailAddress', value);
            }
        },
        isMember: function() {
            return this.$store.state.isMember;
        },
        schedulingAppointment: function() {
            return this.$store.state.schedulingAppointment;
        },
        selectedService: { 
            get() {
                return this.$store.state.selectedService;
            },
            set(value) {
                this.$store.commit('setSelectedService', value);
            }
        },
        selectedServiceDescription: { 
            get() {
                return this.$store.state.selectedServiceDescription;
            },
            set(value) {
                this.$store.commit('setSelectedServiceDescription', value);
            }
        },
        selectedBranch: { 
            get() {
                return this.$store.state.selectedBranch;
            },
            set(value) {
                this.$store.commit('setSelectedBranch', value);
            }
        },
        locations: function() {
            return this.$store.state.locations;
        },
        availableLocations: function() {
            return this.$store.getters.availableLocations;
        },
        // availablePeople: function() {
        //     return this.$store.getters.availablePeople;
        // },
        services: function() {
            return this.$store.state.services;
        },
        locationId: {
            get() {
                return this.$store.state.locationId;
            }
        },
        locationDisplay: {
            get() {
                return this.$store.state.locationDisplay;
            }
        }
    },
    validations: {  
        appointmentTime: {
            required,            
        },
    }

};
</script>